import React from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { Modal } from '../../../components/Modal'
import { ModalType } from '../../../states/modals/ModalType.constants'
import { Map } from '../../../components/Map'
import { GoogleDirectionsLink } from '../../../components/Link/GoogleDirectionsLink'
import { Text } from '../../../components/Text'
import { SCREEN_SIZE } from '../../../static/style'
import { Link } from '../../../components/Link'
import { Image } from '../../../components/Image'
import { CONFIG } from '../../../config'

const StyledMap = styled(Map)`
  width: 100%;
  height: 20rem;
`

const AddressText = styled(Text)`
  margin-right: 0.5rem;
`

const StyledGoogleDirectionsLink = styled(GoogleDirectionsLink)`
  margin: 0;
`

const LabelText = styled(Text)``

const Line = styled.div`
  margin-bottom: 0.5rem;
`

const DescriptionText = styled(Text)``

const ListingLogo = styled(Image)`
  max-height: 3rem;
  max-width: 16rem;
  margin: 0.5rem 0;
`

const WebsiteLink = styled(Link)`
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  ${SCREEN_SIZE.MD} {
    display: inline;
  }
`

const SchoolListingDetailsModal = () => {
  const dispatch = useDispatch()
  const { modalType, data } = useSelector(({ modals }) => modals)
  if (modalType !== ModalType.SCHOOL_LISTING_DETAILS_MODAL) {
    return null
  }
  const {
    contact,
    logo,
    description,
    location: {
      street,
      suburb,
      state,
      postcode,
      coords: [lng, lat],
    },
  } = data
  const website = contact?.website
  const address = `${street}, ${suburb}, ${state} ${postcode}`
  return (
    <Modal header={data.title}>
      {logo && (
        <ListingLogo src={`${CONFIG.LAPUTAN_IMAGE_SERVER_URL}/${logo}`} />
      )}
      {description && (
        <Line>
          <DescriptionText>{description}</DescriptionText>
        </Line>
      )}
      {website && (
        <Line>
          <LabelText>Website:&nbsp;</LabelText>
          <WebsiteLink to={website}>{website}</WebsiteLink>
        </Line>
      )}
      <Line>
        <AddressText>{address}</AddressText>
        <StyledGoogleDirectionsLink coords={{ lat, lng }} />
      </Line>
      <StyledMap
        center={{ lat, lng }}
        markers={[{ lat, lng, popupTitle: data.header }]}
        isShowOverlay={false}
      />
    </Modal>
  )
}

export { SchoolListingDetailsModal }
